// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"feb702b4","453":"a49824f6","980":"1fb1ce24"}[chunkId] + ".chunk.js";
};